import { render } from "./basic-help-box.vue?vue&type=template&id=41b79c70&lang=true"
import script from "./basic-help-box.vue?vue&type=script&lang=js"
export * from "./basic-help-box.vue?vue&type=script&lang=js"

import "./basic-help-box.vue?vue&type=style&index=0&id=41b79c70&lang=css"

import exportComponent from "C:\\Users\\domin\\Desktop\\FIles\\front\\jauris\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__